var map = {
	"./Award & Recognition - 7 - 1080_1080.webp": 2293,
	"./CSR Event - 13 - 1080_1080.webp": 1116,
	"./Conferences & Seminar - 3 - 1080_1080.webp": 7763,
	"./Corporate Event Banner - 3 - 1920_1080.webp": 6663,
	"./Corporate Meeting - 8 - 1080_1080.webp": 8630,
	"./Corporate Parties - 3 - 1080_1080.webp": 8022,
	"./Exhibitions & Trade Shows - 19 - 1080_1080.webp": 8302,
	"./Networking Event - 18 - 1080_1080.webp": 3753,
	"./Press Conferences & Media Event - 10 - 1080_1080.webp": 9195,
	"./Product Launching - 13 - 1080_1080.webp": 9090,
	"./Team Building - 7 - 1080_1080.webp": 3826,
	"./Training Programs - 16 - 1080_1080.webp": 8342,
	"./Virtual Event - 16 - 1080_1080.webp": 6522,
	"./Why Choose Panthi Event - 11 - 1280_720.webp": 8239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4107;